<template>
    <v-content>
        <section>
            <v-parallax :src="require('@/assets/bombe.jpg')" height="300">
                <v-layout
                        column
                        align-center
                        justify-center
                        class="white--text"
                >
                    <img :src="require('@/assets/logo.png')"
                         height="200"
                         class="grey darken-4"
                    />
                    <v-btn
                            class="black white--text lighten-2 mt-5"
                            dark
                            large
                            to="/"
                    >
                        Revenir à l'accueil
                    </v-btn>
                </v-layout>
            </v-parallax>
        </section>
        <section class="xs12">
            <v-layout align-center justify-center>
                <gallery :images="images" :index="index" @close="index = null"></gallery>
                <v-flex>
                    <v-card>
                        <v-container grid-list-sm fluid>
                            <v-layout row wrap>
                                <v-flex
                                        v-for="(image, imageIndex) in images"
                                        :key="imageIndex"
                                        class="xs6 sm4 lg2"
                                        d-flex
                                >
                                    <v-card flat tile class="d-flex" @click="index = imageIndex">
                                        <v-img
                                                :src="image"
                                                aspect-ratio="1"
                                                class="grey lighten-2"
                                        >
                                            <template v-slot:placeholder>
                                                <v-layout
                                                        fill-height
                                                        align-center
                                                        justify-center
                                                        ma-0
                                                >
                                                    <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
                                                </v-layout>
                                            </template>
                                        </v-img>
                                    </v-card>
                                </v-flex>
                            </v-layout>
                        </v-container>
                    </v-card>
                </v-flex>
<!--                <div-->
<!--                        class="image"-->
<!--                        v-for="(image, imageIndex) in images"-->
<!--                        :key="imageIndex"-->
<!--                        @click="index = imageIndex"-->
<!--                        :style="{ backgroundImage: 'url('+ image + ')', width: '300px', height: '200px' }"-->
<!--                ></div>-->
            </v-layout>

            <v-layout align-center justify-center>
                <v-chip class="xs12">
                    <v-icon left>photo_camera</v-icon>
                    Crédit photographie : Suricate Photographie
                </v-chip>
            </v-layout>
        </section>

        <section>
            <v-layout column align-center justify-center>
                <v-flex xs12>
                    <v-btn
                            class="black mt-5"
                            dark
                            large
                            v-on:click="showContact"
                    >
                        Nous contacter
                    </v-btn>
                    <v-btn
                            class="black white--text lighten-2 mt-5"
                            dark
                            large
                            to="/"
                    >
                        Revenir à l'accueil
                    </v-btn>
                </v-flex>
            </v-layout>
        </section>
    </v-content>
</template>

<script>
    import VueGallery from 'vue-gallery';
    import {mapMutations} from 'vuex';
    import axios from 'axios';

    export default {
        name: "Gallery",
        data: function () {
            return {
                images: [
                ],
                index: null,
                imgUrl: "",
            };
        },

        components: {
            'gallery': VueGallery
        },
        methods: {
            ...mapMutations([
                    'showContact',
                    'showMentionLegal'
                ]
            ),
        },
        created() {
            this.imgUrl = process.env.VUE_APP_GALLERY_IMG_URL
            axios.get(process.env.VUE_APP_GALLERY_URL).then(
                response => {
                    console.log(response)
                    this.images = [];
                    response.data.forEach( pic => {
                      this.images.push(this.imgUrl+pic)
                    })

                }
            )
        }
    }
</script>

<style scoped>
    .image {
        float: left;
        background-size: cover;
        background-repeat: no-repeat;
        background-position: center center;
        border: 1px solid #ebebeb;
        margin: 5px;
    }
</style>